export const getCDNBaseURL = () => {
  const baseURL = process.env.REACT_APP_CDN_URL;

  if (!baseURL) {
    return '/';
  }

  return baseURL.endsWith('/') ? baseURL : `${baseURL}/`;
};
